import { getUserInfo } from '@/api/user';

let getUserInfoTask = null;

const user = {
  namespaced: true,
  state: {
    nickName: '加载中...',
    headPortrait: '',
    mobile: 0,
    userGuid: '',
    platformUserGuid: '',
  },

  mutations: {
    SET_STATE: (state, nextState) => {
      Object.assign(state, nextState);
    },
  },

  actions: {
    // 用户名登录
    getUserInfo({ commit }, payload) {
      if (!getUserInfoTask || payload) {
        getUserInfoTask = getUserInfo()
          .then((response) => {
            commit('SET_STATE', response);
            return response;
          }).catch(() => {
            getUserInfoTask = null;
          });
      }
      return getUserInfoTask;
    },
  },
};

export default user;
